import { AfterViewInit, Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DiaryAnswersheetsComponent } from '../../answersheet/diary-answersheets/diary-answersheets.component';
import { DiaryInterface } from '../../../models/interface/diary.interface';

export type DialogPatientDiaryAnswersheetPreviewData = {
  diary_instance_id: number;
  diary: DiaryInterface;
  isManager: boolean;
};

@Component({
  selector: 'app-dialog-patient-diary-answersheet-preview',
  templateUrl: './dialog-patient-diary-answersheet-preview.component.html',
  styleUrls: ['./dialog-patient-diary-answersheet-preview.component.scss'],
})
export class DialogPatientDiaryAnswersheetPreviewComponent implements OnInit, AfterViewInit {
  @ViewChild('answersheetsPreviewContainer', { read: ViewContainerRef }) answersheetsPreviewContainer: ViewContainerRef;

  private components: DiaryAnswersheetsComponent[];

  private diaryInstanceId: number;
  private diary: DiaryInterface;
  private isManager: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: DialogPatientDiaryAnswersheetPreviewData) {}

  ngOnInit(): void {
    this.diaryInstanceId = this.data.diary_instance_id;
    this.diary = this.data.diary;
    this.isManager = this.data.isManager;
  }

  ngAfterViewInit(): void {
    this.components = [];
    if (this.answersheetsPreviewContainer) {
      this.answersheetsPreviewContainer.clear();
    }
    const component = this.answersheetsPreviewContainer.createComponent(DiaryAnswersheetsComponent).instance;
    component._diary_instance_id = this.diaryInstanceId;
    component._diary = this.diary;
    component._is_manager = this.isManager;
    this.components = [...this.components, component];
  }
}
